<template>
  <BaseModal
    :model-value="visible"
    title="Cancel Appointment?"
    width="640px"
    :title-logo="alarmIcon"
    description="Are you sure you want to cancel this appointment? This action cannot be undone."
    @update:model-value="(val) => !val && emit('close')"
    @close="emit('close')"
  >
    <template #footer>
      <div class="flex justify-between items-center w-full">
        <Button
          type="normal"
          color-type="none-stroke"
          @click="emit('close')"
        >
          Cancel
        </Button>
        <Button
          type="normal"
          color-type="red"
          :filled="false"
          @click="emit('cancel')"
        >
          Cancel Appointment
        </Button>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import BaseModal from './BaseModal.vue'
import Button from '@/NewLibrary/Button.vue'
import alarmIcon from '@/assets/my-calendar/white-alarm.svg'

const emit = defineEmits(['close', 'cancel'])
defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
</script>
